<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-data-table :search="search" v-if="!addUser" :headers="headers" :items="usuarios" sort-desc class="elevation-1" style="border-radius: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">USUÁRIOS</v-toolbar-title>
          <v-spacer></v-spacer>
          
          <!-- Seletor de Empresa -->
          <v-autocomplete
            v-if="user.tipo == 'ADMIN'"
            v-model="empresaSelecionada"
            :items="empresas"
            item-text="nome"
            item-value="id"
            label="Selecione uma Empresa"
            outlined
            dense
            hide-details
            class="mr-4"
            style="max-width: 300px;"
            @change="carregaDados"
          ></v-autocomplete>
          
          <v-text-field v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-btn text v-if="user.tipo == 'ADMIN'" @click="addNewUser" tile color="#4A148C">
            <v-icon left dark>add_circle</v-icon> Adicionar novo
          </v-btn>
        </v-toolbar>
      </template>
              <template v-slot:[`item.action`]="{ item }">
          <v-icon @click="editItem(item)" class="mr-2">edit</v-icon>
          <v-icon @click="copiarCredenciais(item)" color="#4A148C">content_copy</v-icon>
        </template>
             <template v-slot:[`item.tipo`]="{ item }">
         {{ formatarTipoUsuario(item.tipo) }}
       </template>
       <template v-slot:[`item.created`]="{ item }">
         {{ formatarData(item.created) }}
       </template>
       <template v-slot:[`item.ativo`]="{ item }">
         <v-chip
           :color="item.ativo ? 'success' : 'error'"
           small
         >
           {{ item.ativo ? 'Ativo' : 'Inativo' }}
         </v-chip>
       </template>
       <template v-slot:no-data>
         <v-btn color="#7B1FA2" @click="carregaDados">Recarregar</v-btn>
       </template>
    </v-data-table>

    <!-- CARD INSERE/EDITA USUÁRIO -->
    <v-card v-else style="border-radius: 10px;">
      <template>
        <v-card-title>
          <span class="textoUser">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <p style="font-size:15px; color:#7B1FA2"> *O preenchimento de todos os campos é obrigatório</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.email" outlined label="E-mail" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.cpf" v-mask="'###.###.###-##'" outlined label="CPF" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.telefone" v-mask="'(##) #####-####'" outlined label="Telefone" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="editedItem.tipo"
                  :items="tiposUsuario"
                  item-text="text"
                  item-value="value"
                  outlined
                  label="Tipo de Usuário"
                  color="#7B1FA2"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="user.tipo === 'ADMIN'">
                <v-select
                  v-model="editedItem.empresaId"
                  :items="empresas"
                  item-text="nome"
                  item-value="id"
                  outlined
                  label="Empresa"
                  color="#7B1FA2"
                  :rules="[v => !!v || 'Empresa é obrigatória']"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field 
                  v-model="editedItem.password" 
                  :type="showPassword ? 'text' : 'password'"
                  outlined 
                  label="Senha" 
                  color="#7B1FA2"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field 
                  v-model="confirmPassword" 
                  :type="showConfirmPassword ? 'text' : 'password'"
                  outlined 
                  label="Confirmar Senha" 
                  color="#7B1FA2"
                  :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showConfirmPassword = !showConfirmPassword"
                ></v-text-field>
              </v-col>
                             <v-col cols="12" sm="6" md="6">
                 <v-switch
                   v-model="editedItem.ativo"
                   label="Usuário Ativo"
                   color="#7B1FA2"
                   class="mt-4"
                 ></v-switch>
               </v-col>
               <v-col cols="12" sm="6" md="6">
                 <v-text-field
                   v-model="editedItem.imagem"
                   outlined
                   label="URL da Imagem"
                   color="#7B1FA2"
                 ></v-text-field>
               </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A148C" class="cssBotao" dark large @click="save">Salvar</v-btn>
          <v-btn color="#BA68C8" max-width="" class="cssBotao" large dark @click="close">Cancelar</v-btn>
        </v-card-actions>
      </template>
    </v-card>

    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
  </v-container>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  components: { Snackbar, Loading },
  data: () => ({
    fullPage: true,
    isLoading: false,
    search: '',
    addUser: false,
    showPassword: false,
    showConfirmPassword: false,
    confirmPassword: '',
    headers: [
      { text: 'Nome', align: 'start', value: 'nome' },
      { text: 'E-mail', value: 'email' },
      { text: 'Tipo', value: 'tipo' },
      { text: 'Status', value: 'ativo', align: 'center' },
      { text: 'Data Criação', value: 'created' },
      { text: 'Ações', value: 'action', align: 'center', sortable: false },
    ],
    usuarios: [],
    editedIndex: -1,
         editedItem: {
       nome: '',
       email: '',
       cpf: '',
       telefone: '',
       tipo: '',
       password: '',
       status: 'ATIVO',
       empresaId: '',
       imagem: '',
       ativo: true,
       created: null
     },
     defaultItem: {
       nome: '',
       email: '',
       cpf: '',
       telefone: '',
       tipo: '',
       password: '',
       status: 'ATIVO',
       empresaId: '',
       imagem: '',
       ativo: true,
       created: null
     },
         tiposUsuario: [
       { text: 'Administrador', value: 'ADMIN' },
       { text: 'Gerente', value: 'GERENTE' },
       { text: 'Checkin', value: 'CHECKIN' }
     ],
    statusOptions: [
      { text: 'Ativo', value: 'ATIVO' },
      { text: 'Inativo', value: 'INATIVO' }
    ],
    empresas: [],
    empresaSelecionada: null,
  }),

  computed: {
    ...mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj
    }),
    formTitle() {
      return this.editedIndex === -1 ? 'ADICIONAR NOVO USUÁRIO' : 'EDITAR USUÁRIO'
    }
  },

  created() {
    if (this.user.tipo === 'ADMIN') {
      this.carregaEmpresas()
    }
  },

  mounted() {
    this.carregaDados()
  },

      methods: {
      async copiarCredenciais(item) {
        try {
          // Get company info
          const companyRes = await axios.get(`${baseApiUrl}Empresas/${item.empresaId}?access_token=${sessionStorage.getItem('accToken')}`);
          const company = companyRes.data;

          // Get active events
          const eventRes = await axios.get(`${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"${item.empresaId}"},{"ativo":"true"}]}}&access_token=${sessionStorage.getItem('accToken')}`);
          let latestEvent = null;
          if (eventRes.data && eventRes.data.length > 0) {
            // Sort events by date and get the most recent one
            latestEvent = eventRes.data.sort((a, b) => new Date(b.created) - new Date(a.created))[0];
          }

          const texto = `${latestEvent ? latestEvent.nome : 'Nenhum evento ativo'}\n\nLink de vendas:\nhttps://aicheckin.com.br/${company.linkVendas}\n\nLink para o ambiente administrativo:\nhttps://aicheckin.com.br/login\n\nAcesso administrativo:\nE-mail: ${item.email}\nSenha: `;
          
          await navigator.clipboard.writeText(texto);
          this.$refs.chamaSnackbar.snack("#0288D1", "Credenciais copiadas para a área de transferência!", "INFORMAÇÃO");
        } catch (err) {
          // console.error('Erro ao copiar credenciais:', err);
          this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao copiar credenciais", "ERRO");
        }
      },

      formatarTipoUsuario(tipo) {
       const tipos = {
         'ADMIN': 'Administrador',
         'GERENTE': 'Gerente',
         'CHECKIN': 'Checkin'
       }
       return tipos[tipo] || tipo
     },

     formatarData(data) {
       if (!data) return '';
       return new Date(data).toLocaleDateString('pt-BR', {
         day: '2-digit',
         month: '2-digit',
         year: 'numeric',
         hour: '2-digit',
         minute: '2-digit'
       });
     },

    async addNewUser() {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.addUser = true
      this.confirmPassword = ''
    },

    async carregaEmpresas() {
      try {
        this.isLoading = true
        const res = await axios.get(`${baseApiUrl}Empresas?access_token=${sessionStorage.getItem('accToken')}`)
        if (res && res.data) {
          this.empresas = Array.isArray(res.data) ? res.data : []
        } else {
          this.empresas = []
          // console.warn('Resposta da API de empresas não contém dados:', res)
          this.$refs.chamaSnackbar.snack("#EF5350", "Resposta da API de empresas não contém dados", "ERRO")
        }
      } catch (error) {
        // console.error('Erro ao carregar empresas:', error)
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar empresas", "ERRO")
        this.empresas = []
      } finally {
        this.isLoading = false
      }
    },

    async carregaDados() {
      try {
        this.isLoading = true
        
        let url
        if (this.user.tipo === 'ADMIN') {
          if (this.empresaSelecionada) {
            url = `${baseApiUrl}usuarios?filter={"where":{"empresaId":"${this.empresaSelecionada}"}}&access_token=${sessionStorage.getItem('accToken')}`
          } else {
            url = `${baseApiUrl}usuarios?access_token=${sessionStorage.getItem('accToken')}`
          }
        } else {
          url = `${baseApiUrl}usuarios?filter={"where":{"empresaId":"${this.companyobj.id}"}}&access_token=${sessionStorage.getItem('accToken')}`
        }
        
        const res = await axios.get(url)
        if (res && res.data) {
          this.usuarios = Array.isArray(res.data) ? res.data : []
        } else {
          this.usuarios = []
          // console.warn('Resposta da API não contém dados:', res)
          this.$refs.chamaSnackbar.snack("#EF5350", "Resposta da API não contém dados", "ERRO")
        }
      } catch (error) {
        // console.error('Erro ao carregar usuários:', error)
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar usuários", "ERRO")
        this.usuarios = []
      } finally {
        this.isLoading = false
      }
    },

    editItem(item) {
      this.editedIndex = this.usuarios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.addUser = true
    },

    async deleteItem(item) {
      const r = confirm('Deseja realmente excluir o usuário: ' + item.nome + '?')
      if (r) {
        this.isLoading = true
        try {
          await axios.delete(`${baseApiUrl}usuarios/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          this.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
          await this.carregaDados()
        } catch (error) {
          this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao excluir usuário", "ERRO")
        } finally {
          this.isLoading = false
        }
      }
    },

    close() {
      this.addUser = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.confirmPassword = ''
      }, 300)
    },

    async save() {
      this.isLoading = true
      try {
        // Validações básicas
        if (!this.editedItem.nome || !this.editedItem.email || !this.editedItem.tipo) {
          throw new Error("Nome, e-mail e tipo de usuário são obrigatórios")
        }

        // Validação de empresa para administradores
        if (this.user.tipo === 'ADMIN' && !this.editedItem.empresaId) {
          throw new Error("Selecione uma empresa")
        }

        // Validação de senha
        if (this.editedItem.password || this.confirmPassword) {
          if (!this.editedItem.password) {
            throw new Error(this.editedIndex === -1 ? "A senha é obrigatória para novos usuários" : "Digite a nova senha.")
          }
          if (this.editedItem.password !== this.confirmPassword) {
            throw new Error("As senhas não coincidem")
          }
        }

        const itemToSave = { ...this.editedItem }

        if (this.editedIndex > -1) {
          // Atualizando usuário existente
          await axios.patch(
            `${baseApiUrl}usuarios/${itemToSave.id}?access_token=${sessionStorage.getItem('accToken')}`,
            itemToSave
          )
          this.$refs.chamaSnackbar.snack("#0288D1", "Usuário atualizado com sucesso!", "INFORMAÇÃO")
        } else {
          // Criando novo usuário
          if (this.user.tipo !== 'ADMIN') {
            itemToSave.empresaId = this.companyobj.id
          }
          itemToSave.created = new Date().toISOString()
          await axios.post(
            `${baseApiUrl}usuarios/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`,
            itemToSave
          )
          this.$refs.chamaSnackbar.snack("#0288D1", "Usuário cadastrado com sucesso!", "INFORMAÇÃO")
        }
        
        await this.carregaDados()
        this.close()
      } catch (error) {
        this.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Erro: " + (error.response.data.error.message || error.message),
          "ERRO"
        )
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 150px;
  font-size: 7px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>
